import gql from 'graphql-tag';

export const searchTargetTimeRules = gql`
  query searchTargetTimeRules(
    $channelId: UUID!
    $pagination: PaginationInput!
  ) {
    searchTargetTimeRules(channelId: $channelId, pagination: $pagination) {
      targetTimeRules {
        id
        groupId
        category
        issue
        targetResponseSeconds
        targetCompletionSeconds
        createdAt
        updatedAt
        createdBy
        updatedBy
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
